var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aminwidth",attrs:{"id":"app"}},[_c('NavTop'),_c('b-container',{staticClass:"mt-3 mt-md-4"},[_c('router-view')],1),_c('NavBtm'),_c('BackgroundCheck'),_c('CookieCheck')],1)}
var staticRenderFns = []

export { render, staticRenderFns }